import { CSSProperties } from "react"
import { app } from "../app"
import { BlockServices, BlockChannels, Footer } from "."
import { CookieBanner } from "./cookie-banner"

export function ServicesMapComponent() {
  const blocks = app.page.content || []

  const sortedBlocks = blocks
    .filter((b) => b.type === "services" || b.type === "channels")
    .sort((a, b) => {
      if (a.type === "services" && b.type === "channels") return -1
      if (a.type === "channels" && b.type === "services") return 1
      return 0
    })

  const filteredBlocks = sortedBlocks.map((b) => {
    if (b.type === "services") {
      return <BlockServices key={b.sort} block={b as BlockServices} />
    }
    if (b.type === "channels") {
      return <BlockChannels key={b.sort} block={b as BlockChannels} />
    }
    return null
  })

  return (
    <div className="overflow-y-auto h-full flex justify-center w-full">
      <div className="w-full">
        {filteredBlocks}
        <Footer />
        <CookieBanner />
      </div>
    </div>
  )
}

ServicesMapComponent.buildStyle = (block: Block) => {
  const styles: CSSProperties = {}

  if (block) {
    if (block.textsize) styles.fontSize = `${block.textsize}%`
    if (block.textcolor) styles.color = block.textcolor
    if (block.bgcolor) styles.backgroundColor = block.bgcolor
    if (block.fontweight) styles.fontWeight = block.fontweight
  }

  return styles
}
